import { createApp, computed } from "vue";
import "./style.css";
import App from "./App.vue";
import router from "./router"; // Vue 페이지 이동 라이브러리
import { createVuetify } from "vuetify"; // Vue 디자인 라이브러리
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import { createPinia } from "pinia"; // Vue 상태관리 라이브러리
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import axios from "axios"; // API 호출
import i18n from "./lib/i18n"; // 다국어 처리
import ko from "./lib/i18n/locales/ko.json";
import en from "./lib/i18n/locales/en.json";
import vuetifyKo from "vuetify/lib/locale/ko.mjs";
import vuetifyEn from "vuetify/lib/locale/en.mjs";
import "./assets/styles/baseStyle.css"; // 기본 css
// import "./assets/styles/alpine.css";
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import { VDateInput } from "vuetify/labs/VDateInput";
import { useAppStateStore } from './stores/appState';
import { useUserStateStore } from "./stores/userState";
import { refreshFavicon } from "./utils/branding";

const app = createApp(App);
const messages = {
  ko: { ...vuetifyKo, ...ko },
  en: { ...vuetifyEn, ...en },
};
const vuetify = createVuetify({
  locale: {
    locale: i18n.global.locale.value,
    messages,
  },
  components: {
    VDateInput,
  },
  theme: {
    defaultTheme: "dark",
    themes: {
      light: {
        dark: false,
        colors: {
          background: "#ffffff",
          sheet: "#f5f5f5",
          surface: "#f5f5f5",
          primary: "#6200ea",
          secondary: "#03dac6",
          error: "#b00020",
          text: "#000000",
          queryHeader: '#eff6ff'
        },
        variables: {
          'field-border-color': '#e9ecef',
        },
      },
      dark: {
        dark: true,
        colors: {
          background: "#010614",
          sheet: "#010614",
          // surface: "#020202",
          primary: "#bb86fc",
          secondary: "#03dac6",
          error: "#cf6679",
          text: "#ffffff",
          queryHeader: '#eff6ff',
        },
      },
      variables: {
        'field-border-color': '#3a3b3d',
      },
    },
  },
});
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(router);
app.use(vuetify);
app.use(pinia);
app.use(i18n);

const appState = useAppStateStore();
const userState = useUserStateStore();
userState.initSessionControl();
i18n.global.locale.value = appState.currentLocale;
vuetify.locale.current.value = appState.currentLocale;
vuetify.theme.global.name.value = appState.currentTheme;

app.config.globalProperties.$axios = axios;
app.use(VueViewer);
app.mount("#app");

// 파비콘 적용 (khrdc 고정 / 그 외는 학회 아이콘 조회 후 없으면 U2EDC 기본)
refreshFavicon(userState.AssociationID);
